<template>
    <client-page>
        <sub-visual sh="시설 및 참여" tabActive="코칭스탭" bg="/images/sub/visual/sv2.jpg"> </sub-visual>

        <section class="section">
            <v-container>
                <dept3-tab page="코칭스탭" tabActive="2" />
                <sub-staff-tab />

                <staff-profile-layout v-bind="profile" />
            </v-container>
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import Dept3Tab from "@/components/client/ko/sub/dept3-tab.vue";
import SlidePrimary from "@/components/client/ko/sub/sub-slide-primary.vue";
import StaffTop from "@/components/client/ko/sub/sub-staff-top.vue";

import SubStaffTab from "@/components/client/ko/sub/sub-staff-tab.vue";
import StaffProfileLayout from "@/components/client/ko/center/staff-profile-layout.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        Dept3Tab,
        SlidePrimary,
        StaffTop,

        SubStaffTab,
        StaffProfileLayout,
    },

    data() {
        return {
            profile: [
                {
                    position: "코치",
                    name: "김현웅",
                    items: [
                        {
                            subject: "학력",
                            content: [
                                "충북 충주상고",
                                "C.F Fuenlabrada S.A.D (스페인 라리가 2부)",
                                "C.F Fuenlabrada S.A.D (스페인 라리가 4부)",
                                "Real Aranjuez C.F (스페인 3부)",
                                "양주시민축구단 (K3)",
                                //
                            ],
                        },
                        {
                            subject: "경력",
                            content: [
                                "2023 포천슛돌이 FC코치 (선수반, 여성축구)",
                                //
                            ],
                        },
                        {
                            subject: "상훈/자격증",
                            content: [
                                "전문스포츠 지도자 2급(축구)",
                                //
                            ],
                        },
                        {
                            subject: "지도",
                            content: [
                                "재단법인 유더스타스포츠 ″핫둘핫둘 유아스포츠단 및 지역아동 센터 축구감독″",
                                //
                            ],
                        },
                        {
                            subject: "이메일",
                            content: [
                                "hyeonung@uthestar.org",
                                //
                            ],
                        },
                    ],
                    image: "/images/sub/center/staff/KimHyunwoong.jpg",
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped></style>
